(function (angular) {
	'use strict';

	var newsFeedObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			items: '<',
			loading: '<'
		},
		controller: [
			NewsFeedFunction
		],
		controllerAs: 'newsFeed'
	};

	angular
		.module('newsFeedModule')
		.component('newsFeed', newsFeedObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/news-feed/news-feed.html';
	}

	function NewsFeedFunction() {
		var newsFeed = this;
	}
})(window.angular);